var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClearCoupon = function SvgClearCoupon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 14 14"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clear-coupon_svg__a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 7,
    fill: "#fff",
    "data-name": "Ellipse 100",
    transform: "translate(1141.679 493.679)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clear-coupon_svg__a)",
    "data-name": "Mask Group 16",
    transform: "translate(-1141.679 -493.679)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1145.648 493.68h6.069a3.839 3.839 0 0 1 3.962 4.143v5.72a3.836 3.836 0 0 1-3.962 4.137h-6.069a3.841 3.841 0 0 1-3.969-4.137v-5.72a3.844 3.844 0 0 1 3.969-4.143m5.138 9.1a.608.608 0 0 0 0-.86l-1.246-1.247 1.246-1.247a.614.614 0 1 0-.868-.867l-1.239 1.245-1.246-1.245a.614.614 0 0 0-.868.867l1.246 1.247-1.246 1.239a.616.616 0 0 0 0 .867.623.623 0 0 0 .434.183.61.61 0 0 0 .434-.183l1.246-1.238 1.246 1.239a.576.576 0 0 0 .427.183.61.61 0 0 0 .434-.183",
    "data-name": "Path 18640"
  }))));
};
export default SvgClearCoupon;